<template>
  <div v-if="data">
    <Top />
    <!-- <Dev> -->
    <!-- v-if = ?fakelogin=true -->
    <div class="btn-group dev" v-if="$route.query.fakelogin === 'true' && (isDev || isQa)">
      <button type="button" class="dropdown-toggle text-primary-fh"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Testning 🧰
      </button>
      <div class="dropdown-menu">
        <a class="dropdown-item text-primary-fh" @click="openDev('login')">
          <strong>Inloggning</strong>
        </a>
        <a class="dropdown-item text-primary-fh" @click="openDev('register')">
          Registrering
        </a>
        <a class="dropdown-item text-primary-fh" @click="clearStorages()">
          Rensa storages
        </a>
      </div>
    </div>
    <div class="m-top" v-if="dev_login">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">förnamn</span>
        </div>
        <input type="text" v-model="temp.givenName" aria-label="givenName" class="form-control"
          @input="temp.givenName = temp.givenName.replace(/\s/g, '')" placeholder="ex: Sven" />
      </div>
      <div class="clearfix--min"></div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">efternamn</span>
        </div>
        <input type="text" v-model="temp.surName" aria-label="surname" class="form-control"
          @input="temp.surName = temp.surName.replace(/\s/g, '')" placeholder="ex: Andersson" />
      </div>
      <div class="clearfix--min"></div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">invitelänk</span>
        </div>
        <input type="text" v-model="temp.invitationLink" aria-label="invitationLink" class="form-control"
          @input="temp.invitationLink = temp.invitationLink.replace(/\s/g, '')"
            placeholder="ex: a9fb8545-22b7-4d6d-8d4c-bcef212a6153" />
      </div>
      <div class="clearfix--min"></div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">ssn/pnr</span>
        </div>
        <input type="text" v-model="temp.ssn" aria-label="ssn" class="form-control"
          @input="temp.ssn = temp.ssn.replace(/\s/g, '')" @keyup.enter="relativeLogin()" placeholder="ex: 198010101234" />
      </div>
      <div class="clearfix--min"></div>
      <input type="button" class="btn btn-info btn-md btn-block"
        @click="relativeLogin()" :disabled="!temp.givenName || !temp.surName || !temp.ssn" value="Logga in" />
      <div class="clearfix--min"></div>
      <div class="alert alert-info div-loader">Laddar</div>
      <div class="alert alert-danger alert-error"></div>
    </div>
    <div class="m-top" v-if="dev_register">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">ssn/pnr</span>
        </div>
        <input type="text" v-model="temp.ssn" aria-label="ssn" class="form-control"
          @input="temp.ssn = temp.ssn.replace(/\s/g, '')" placeholder="ex: 198010101234" />
      </div>
      <div class="clearfix--min"></div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">invitelänk</span>
        </div>
        <input type="text" v-model="temp.invitationLink" aria-label="invitationLink" class="form-control"
          @input="temp.invitationLink = temp.invitationLink.replace(/\s/g, '')" @keyup.enter="relativeRegister()"
            placeholder="ex: a9fb8545-22b7-4d6d-8d4c-bcef212a6153" />
      </div>
      <div class="clearfix--min"></div>
      <input type="button" class="btn btn-info btn-md btn-block"
        @click="relativeRegister()" :disabled="!temp.ssn || (!temp.invitationLink || !isGuid)" value="Registrera" />
      <div class="clearfix--min"></div>
      <div class="alert alert-info div-loader">Laddar</div>
      <div class="alert alert-danger alert-error">
        <strong>Något fält är fel, försök igen</strong>
      </div>
      <div class="alert alert-success alert-reg">
        <strong>Registrering lyckades</strong>
      </div>
    </div>
    <!-- </Dev> -->

    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <img src="@/assets/img/family.svg?data" alt="Bild på familj" class="img-fluid" />
          <br />
          <img src="@/assets/img/logo.svg?data" alt="FHabian.nu logotyp" class="img-fluid img-logo-xl" />
          <hr />
          <h1 class="text-primary-fh" v-html="data.startpage.welcomeHeader"></h1>
          <p v-html="data.startpage.welcomeText"></p>
          <p v-html="data.landingpage.alreadyregisteredtext"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div id="relativeAlreadyRegistered" class="alert alert-info" v-show="relativeAlreadyRegistered">
            Du är redan registrerad, vänligen logga in som vanligt nedan.
          </div>
          <small class="text-muted" v-if="showHelp">Format: <i>YYYYMMDDXXXX</i></small>
          <br />
          <div class="clearfix--min"></div>
          <button @click="loginWithBankId()">
            <img
              src="@/assets/img/bankid-btn.svg?data"
              alt="Knapp för inloggning med BankID"
              class="img-fluid"
             />
          </button>
          <div class="clearfix"></div>
          <button @click="loginWithFreja()">
            <img
              src="@/assets/img/freja-btn.svg?data"
              alt="Knapp för inloggning med Freja eID"
              class="img-fluid"
            />
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="text-content">
            <p v-html="data.startpage.ageClarificationText"></p>
          </div>
          <div class="clearfix"></div>
          <img
            src="@/assets/img/tree-prototype.svg?data"
            alt="Bild på en släktträdsprototyp"
            class="img-fluid"
          />
          <div class="clearfix"></div>
          <div class="text-content">
            <h4 class="text-danger" v-html="data.startpage.whatisfhHeader"></h4>
            <p v-html="data.startpage.whatisfhText"></p>
          </div>
          <div class="text-content">
            <h4 class="text-danger" v-html="data.startpage.howtotreatfhHeader"></h4>
            <p v-html="data.startpage.howtotreatfhText"></p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'startpage',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      showHelp: false,
      dev_login: false,
      dev_register: false,
      relativeAlreadyRegistered: false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      temp: {
        givenName: '',
        surName: '',
        sessionID: 'temp-s-id',
        ssn: '',
        invitationLink: ''
      }
    }
  },
  computed: {
    isGuid () {
      const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      return pattern.test(this.temp.invitationLink)
    }
  },
  methods: {
    /* dev area begins */
    openDev (area) {
      this.temp.invitationLink = ''
      switch (area) {
        case 'login':
          this.dev_register = false
          this.dev_login = !this.dev_login
          break
        case 'register':
          this.dev_login = false
          this.dev_register = !this.dev_register
          break
        default:
          break
      }
    },
    relativeLogin () {
      if ((this.isDev || this.isQa) && (this.temp.givenName && this.temp.surName && this.temp.ssn)) {
        $('.div-loader').show()
        this.clearStorages()
        this.temp.invitationLink = this.temp.invitationLink.replace('?iid=', '')
        this.temp.ssn = this.temp.ssn.replaceAll('-', '')
        axios.postTokenTest(config.tokenTestUri, this.temp).then((response) => {
          if (response) {
            sessionStorage.setItem('devlogin', true)
            sessionStorage.setItem('jwt', response.data)
            sessionStorage.setItem('fullname', this.temp.givenName + ' ' + this.temp.surName)
            sessionStorage.setItem('sessionId', this.temp.sessionID)
            localStorage.setItem('uri', config.tokenBankIdUri)
            window.location.href = window.location.origin.concat('/welcome')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            $('.div-loader').hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            const err = error.response.data ? error.response.data[0] : 'Något fält är fel, försök igen'
            $('.div-loader').hide()
            $('.alert-error').text(err).show().delay(config.msInterval).fadeOut()
            console.log(error)
          }
        })
      }
    },
    relativeRegister () {
      if ((this.isDev || this.isQa) && (this.temp.ssn && this.temp.invitationLink && this.isGuid)) {
        $('.div-loader').show()
        this.clearStorages()
        const regData = {
          ssn: this.temp.ssn,
          invitationLink: this.temp.invitationLink.replace('?iid=', '')
        }
        axios.postRegistration(config.relativeUri + config.registrationUri, regData).then((response) => {
          if (response) {
            $('.div-loader').hide()
            $('.alert-reg').show().delay(config.msInterval).fadeOut()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            $('.div-loader').hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            const err = error.response.data ? error.response.data[0] : 'Något fält är fel, försök igen'
            $('.div-loader').hide()
            $('.alert-error').text(err).show().delay(config.msInterval).fadeOut()
          }
        })
      }
    },
    clearSessionStorage () {
      if (this.isDev || this.isQa) {
        sessionStorage.clear()
        const res = {
          ...sessionStorage
        }
        console.log('sessionStorage should be cleared, current: ' + JSON.stringify(res))
      }
    },
    clearLocalStorage () {
      if (this.isDev || this.isQa) {
        localStorage.clear()
        const res = {
          ...localStorage
        }
        console.log('localStorage should be cleared, current: ' + JSON.stringify(res))
      }
    },
    clearStorages () {
      this.clearSessionStorage()
      this.clearLocalStorage()
    },
    /* dev area ends */
    loginWithBankId () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      localStorage.removeItem('uri')
      this.clearSessionStorage()
      axios.postLogin(config.bankIdUri, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.setItem('uri', config.tokenBankIdUri)
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    loginWithFreja () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      localStorage.removeItem('uri')
      this.clearSessionStorage()
      axios.postLogin(config.frejaUri, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.setItem('uri', config.tokenFrejaUri)
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    setFocusAndHandleIfAlreadyRegistered () {
      setTimeout(() => {
        if (sessionStorage.getItem('relativeAlreadyRegistered') === 'true') {
          this.relativeAlreadyRegistered = true
          sessionStorage.removeItem('relativeAlreadyRegistered')
          const element = document.getElementById('relativeAlreadyRegistered')
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }, 1111)
        }
        window.scrollTo(0, 0)
      })
    },
    enterKeyHandler () {
      this.loginWithBankId()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          startpage {
            welcomeHeader
            welcomeText
            whatisfhHeader
            whatisfhText
            ageClarificationText
            howtotreatfhHeader
            howtotreatfhText
          }
          landingpage {
            alreadyregisteredtext
          }
        }
      `
    })
    this.setFocusAndHandleIfAlreadyRegistered()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button,
input[type="submit"],
input[type="reset"] {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.alert-error, .alert-reg {
  display: none;
}
.m-top {
  margin-left: 35px;
  margin-top: 80px;
  position: absolute;
  width: 400px;
  z-index: 999;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .dev {
    margin: 50px;
  }
  .m-top {
    width: 85vw;
  }
}
.dev {
  margin-left: 35px;
  margin-top: 25px;
  float: left;
  cursor: pointer;
}
.dev > button {
  border-radius: 5px;
  border: 1px solid #069ccc;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/StartPage.vue